import React from 'react'
import BGContainer from '../../Components/BGContainer'
import { Container, useMediaQuery } from '@mui/material'
import Centered from '../../Components/Centered'
import Reference from '../Reference'
import { RezervovatButton } from '../Main/MainPage'
import { EditableTypography } from '../../Components/EditableTypography'
import { pastelBlue, titleStyle } from '../Main/constants'
import { theme } from '../../Resources/Design/theme'

export default function ReferencePage() {
    const mobile = useMediaQuery(theme.breakpoints.only("xs"));

    return (
        <div>
            <BGContainer id={"reference"} sx={{ py: '120px' }}>
                <Container maxWidth='lg' sx={{ mt: '120px', ...(mobile ? { px: '0px !important' } : {}) }}>
                    <Centered>
                        <EditableTypography fireKey={'reference'} sx={{ mt: '0px', ...titleStyle, textAlign: 'center', mb: '120px' }} />
                    </Centered>
                    <Reference />
                </Container>
            </BGContainer>

            <BGContainer sx={{ pb: '120px', pt: '0px' }}>
                <Container maxWidth='lg' sx={{ mt: '0px' }}>
                    <RezervovatButton sx={{ pt: '0px' }} buttons={false} />
                </Container>
            </BGContainer>
        </div>
    )
}
